<template>
  <div class="box">
    <div class="teamContainer pb-2">
      <div class="team-month px-2 pt-2">
        <att-header class="customize-tab-style"></att-header>
        <div class="month-box">
          <div class="swiper-container month-banner">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in monthList"
                :key="index"
              >
                <p
                  class="item"
                  :class="{ active: item.isActive }"
                  @click="getTeamData(item.curDay, index)"
                >
                  {{ item.day }}月
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="base p-4">
          <div class="sec-title">
            <p>上下班统计-人</p>
            <span v-if="!isMobile" class="btns" @click="toShowDetail"
              >查看明细</span
            >
          </div>
          <div class="list">
            <div
              class="item"
              v-for="(item, index) in list.workList"
              :key="index"
              @click="toCountDetail(item)"
            >
              <p>{{ team.work[item.prop] }}</p>
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="normal base work p-4 mt-2">
        <div class="sec-title">加班统计-人</div>
        <div class="list">
          <div
            class="item"
            v-for="(item, index) in list.overtimeList"
            :key="index"
            @click="toCountDetail(item)"
          >
            <p>{{ team.overtime[item.prop] }}</p>
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="normal base p-4 mt-2" @click="jumpPage('KQ')" v-if="recordData.workNotConfirm || recordData.workConfirm">
        <div class="sec-title">考勤通知统计-人</div>
        <div class="list">
          <div
            class="item"
            v-for="(item, index) in list.noticeList"
            :key="index"
            @click="toCountDetail(item)"
          >
            <p>{{ recordData[item.prop] }}</p>
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="normal base p-4 mt-2" @click="jumpPage('XJ')" v-if="recordData.holiadyNotConfirm || recordData.holiadyConfirm">
        <div class="sec-title">调休/年假到期统计-人</div>
        <div class="list">
          <div
            class="item"
            v-for="(item, index) in list.maturityList"
            :key="index"
            @click="toCountDetail(item)"
          >
            <p>{{ recordData[item.prop] }}</p>
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="normal holiday base p-4 mt-2">
        <div class="sec-title">假期统计-人</div>
        <div class="list">
          <div
            class="item"
            v-for="(item, index) in list.vacationList"
            :key="index"
            @click="toCountDetail(item)"
          >
            <p>{{ team.vacation[item.prop] }}</p>
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import attHeader from "@/components/attendance/att-header.vue";
import Swiper from "swiper";
import utils from '@/utils/utils'
import api from '@/apis'
export default {
  name:'team',
  components: { attHeader },
  created() {
    this.dealMonth();
  },
  mounted() {
    let month = utils.formatDate(new Date() / 1000, "yyyy-MM");
    this.getTeamData(month);

    this.$nextTick(() => {
      this._init_swiper();
    });
  },
  data() {
    return {
      nowMonth: "",
      team: {
        work: {},
        overtime: {},
        vacation: {},
      },
      recordData: {},
      list: {
        workList: [
          {
            name: "迟到",
            prop: "latesum",
            value: 1,
          },
          {
            name: "早退",
            prop: "earlysum",
            value: 2,
          },
          {
            name: "旷工",
            prop: "absent",
            value: 3,
          },
          {
            name: "签卡",
            prop: "card",
            value: 4,
          },
        ],
        overtimeList: [
          {
            name: "工作日加班",
            prop: "workday",
            value: 5,
          },
          {
            name: "休息日加班",
            prop: "weekend",
            value: 6,
          },
          {
            name: "节假日加班",
            prop: "holiday",
            value: 7,
          },
        ],
        noticeList: [
          {
            name: "已确认",
            prop: "workConfirm",
            value: 20,
          },
          {
            name: "未确认",
            prop: "workNotConfirm",
            value: 21,
          },
        ],
        maturityList: [
          {
            name: "已确认",
            prop: "holidayConfirm",
            value: 22,
          },
          {
            name: "未确认",
            prop: "holiadyNotConfirm",
            value: 23,
          },
        ],
        vacationList: [
          {
            name: "年假",
            prop: "nj",
            value: 8,
          },
          {
            name: "事假",
            prop: "sj",
            value: 9,
          },
          {
            name: "病休假",
            prop: "bxj",
            value: 10,
          },
          {
            name: "产假",
            prop: "cj",
            value: 11,
          },
          {
            name: "出差",
            prop: "cc",
            value: 12,
          },
          {
            name: "调休",
            prop: "tx",
            value: 13,
          },
          {
            name: "病假",
            prop: "bj",
            value: 14,
          },
          {
            name: "丧假",
            prop: "saj",
            value: 15,
          },
          {
            name: "婚假",
            prop: "hj",
            value: 16,
          },
          {
            name: "产检假",
            prop: "cjj",
            value: 17,
          },
          {
            name: "陪产假",
            prop: "pcj",
            value: 18,
          },
          {
            name: "哺乳假",
            prop: "brj",
            value: 19,
          },
        ],
      },
      monthList: [],
      monthSwiper: null,
      isMobile: utils.parseUA().mobile,
    };
  },
  methods: {
    //跳转详情页
    jumpPage(flag) {
      this.$router.push({
        path: '/confirmDetail',
        query: {
          month: this.nowMonth,
          flag,
        }
      })
    },
    //跳转
    toCountDetail(item) {
      this.$router.push({
        path: "/countNum",
        query: {
          name: item.name,
          type: item.value,
          month: this.nowMonth,
        },
      });
    },
    // 获取前后六个月
    dealMonth() {
      let now = new Date().getMonth() + 1;
      let max = now + 5;
      let min = now - 6;
      while (min < max) {
        let day = utils.formatDate(new Date().setMonth(min) / 1000, "MM");
        let curDay = utils.formatDate(
          new Date().setMonth(min) / 1000,
          "yyyy-MM"
        );
        let isActive = parseInt(day) == now;
        this.monthList.push({
          day: day,
          curDay: curDay,
          isActive: isActive,
        });
        min++;
      }
    },
    //跳转
    toShowDetail() {
      this.$router.push({ path: "/punch" });
    },
    //获取考勤数据
    getTeamData(month, index) {
      if (index || index === 0) {
        this.monthList.forEach((item) => {
          item.isActive = false;
        });
        this.monthList[index].isActive = true;
      }
      this.nowMonth = month;
      api.teamData({ month: month }).then((res) => {
        this.team = res.data;
      });


      // 新增功能接口数据---(考勤通知统计-人 & 调休/年假到期统计-人)数据
      const salaryInfo = JSON.parse(localStorage.getItem("salaryInfo"));
      api.selelctConfirmRecord({
        month: month,
        empNo: salaryInfo.empNo,
      }).then((res) => {
        this.recordData = res.data;
      });
    },
    //初始化swiper
    _init_swiper() {
      this.monthSwiper = new Swiper(".month-banner", {
        loop: false,
        slidesPerView: 6,
        loopedSlides: 6,
      });
    },
  },
};
</script>


<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .teamContainer {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .teamContainer {
    width: 276px * $zoom;
  }
}
.box {
  display: flex;
  justify-content: center;
}
.teamContainer {
  // @include container();
  background: #F7F9FA;
  .team-month {
    background: #ffffff;
    border-radius: 10px;
    .customize-tab-style {
      ::v-deep .active {
        position: relative;
        z-index: 1;
        height: 72px;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #fff;
        line-height: 72px;
        &::after {
          position: absolute;
          left: 50%;
          top: 0;
          transform: translateX(-50%);
          z-index: -1;
          width: 184px;
          height: 72px;
          background: linear-gradient(90deg, #69B299 0%, #4DA27B 100%);
          box-shadow: 6px 8px 2px 0px rgba(16,201,103,0.14);
          border-radius: 0px 20px 20px 20px;
        }
      }
    }
    .month-box {
      height: 100px;
      .month-banner {
        height: 100%;
        .masonry-slide {
          @include flex-center();
          height: 100%;
          cursor: pointer;
        }
        .item {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          font-size: 30px;
          font-family: SimHei;
          font-weight: 500;
          color: #999999;
          line-height: 70px;
          text-align: center;
        }
        .active {
          // background: #3a86f4;
          // color: #ffffff;
          position: relative;
          color: #4EA27C;
          &::after {
            position: absolute;
            left: 50%;
            bottom: -10px;
            transform: translateX(-50%);
            width: 28px;
            height: 22px;
            background: url('../../assets/img/triangle.png') no-repeat;
            background-size: 28px 22px;
            content: '',
          }
        }
      }
    }
  }
  .base {
    .sec-title {
      font-size: 32px;
      font-family: PingFang-SC-Heavy, PingFang-SC;
      font-weight: 800;
      color: #282B32;
      @include flex-between();
      & > .btns {
        width: 136px;
        height: 40px;
        // border: 1px solid #3a86f4;
        border-radius: 20px;
        font-size: 24px;
        font-family: SimHei;
        font-weight: 400;
        // color: #3a86f4;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        border: 1px solid #4EA27C;
        color: #4EA27C;
      }
    }
    .list {
      margin-top: 30px;
      @include flex-start();
      flex-wrap: wrap;
      .item {
        width: 25%;
        cursor: pointer;
        @include flex-center(column);
        & > p {
          font-size: 40px;
          font-family: SimHei;
          font-weight: 600;
          color: #1e1e1e;
        }
        & > span {
          margin-top: 6px;
          font-size: 24px;
          font-family: SimHei;
          font-weight: 400;
          color: #999999;
        }
      }
    }
  }
  .normal {
    background: #ffffff;
    border-radius: 16px;
    margin: 24px 24px 0;
  }
  .work {
    .list {
      @include flex-between();
    }
  }
  .holiday {
    .list {
      .item {
        margin-bottom: 40px;
      }
    }
  }
}
</style>
